import accordions from './accordions';
import tabs from './tabs';
import homepage_slider from './homepage_slider';
import Glide from '@glidejs/glide';
import setupAlerts from './alert';
import header from './header';

document.addEventListener('DOMContentLoaded', accordions, false);
document.addEventListener('DOMContentLoaded', tabs, false);
document.addEventListener('DOMContentLoaded', homepage_slider, false);
document.addEventListener('DOMContentLoaded', setupAlerts, false);
document.addEventListener('DOMContentLoaded', header, false);

$(document).ready(function () {
    // make accordions accessible via keyboard
    $('.accordion_object_header').each(function () {
        $(this).attr('tabindex', 0);
        $(this).attr('role', 'button');
    });

    document.getElementById('mobileMenuBtn--container').addEventListener('click', toggleMobileMenu);

    $('#hideSearch').click(function () {
        $('.search').removeClass('open');
        $('.mainHeader').removeClass('search-open');
    });

    $('.expandTrigger').click(function () {
        $(this).parent().find('.expandable').addClass('open');
        return false;
    });

    if (document.querySelector('.glide .glide__slide')) {
        // Fellow Slider
        const glideOptions = {
            type: 'carousel',
            startAt: 0,
            gap: 0,
            autoplay: 7000,
            perView: 1
        };
        const glide = new Glide('.glide', glideOptions);
        glide.on('run.before', function (event) {
            if (event.direction === '>') {
                event.steps = -glide.settings.perView;
            } else if (event.direction === '<' && event.steps !== '<') {
                event.steps = glide.settings.perView;
            }
        });
        glide.mount();
        glide.go('<<');
    }

    //turn sidebar into accordion on mobile (copied from wt-lu-blocks, with different class)
    //uses JQ because they couldnt figure out how to get the .stop calls working with plain JS
    //this header is completely hidden on desktop, so no need to do seperate width check here
    $('.mobile_accordion_object_header').on('click', function (e) {
        const icon = $(this).find($('.initialIcon, .initialIconV2'));
        const collapsible = $(this).parent().find($('.mobile_accordion_object_collapsible_content'));
        if (icon.hasClass('active')) {
            icon.removeClass('active');
            collapsible.removeClass('open');
            collapsible.stop(true, true).slideUp(250);
        } else {
            icon.addClass('active');
            collapsible.addClass('open');
            collapsible.stop(true, true).slideDown(250);
        }
    });

    // prevent menu items with '#' from adding the '#' to the url when clicked
    document.querySelectorAll('.menu-item-has-children > a').forEach(item => {
        item.addEventListener('click', function(event) {
            if (item.getAttribute('href') === '#') {
             event.preventDefault(); 
            }
        });
    });

});

function toggleMobileMenu() {
    var mobileMenuButton = document.getElementById('mobileMenuBtn--container');
    mobileMenuButton.classList.toggle('active');

    if (mobileMenuButton.classList.contains('active')) {
        mobileMenuButton.ariaLabel = "Close";
    } else {
        mobileMenuButton.ariaLabel = "Open menu";
    }


    var menu = document.getElementById('mobileMenu');
    if (menu.classList.contains('mobileMenu--active')) {
        menu.classList.remove('mobileMenu--active');
        document.body.classList.remove('noscroll');
        document.getElementById('footer').classList.remove('hidden');
        mobileMenuTabindex('mobileMenu', '-1');
        var tabContent = document.querySelector('.tabContent--active');
        if (tabContent != null) {
            tabContent.classList.remove('tabContent--active');
            document.getElementById('mobileMenu__mainMenu').classList.remove('mainMenu--hidden');
        }
        document.removeEventListener('click', mobileMenuCloseClickOutside, false);
    } else {
        menu.classList.add('mobileMenu--active');
        document.body.classList.add('noscroll');
        document.getElementById('footer').classList.add('hidden');
        mobileMenuTabindex('mobileMenu__mainMenu', '0');
        mobileMenuTabindex('mobileMenu__searchForm', '0');
        document.getElementById('mobileMenu').scroll({ top: 0, behavior: 'instant' });
        document.addEventListener('click', mobileMenuCloseClickOutside, false);
    }
}
function mobileMenuTabindex(elemId, tabindex) {
    var elems = document.getElementById(elemId)
        .querySelectorAll('button,input,a');
    for (var i = 0; i < elems.length; i++) {
        elems[i].setAttribute('tabindex', tabindex);
    }
}

function mobileMenuCloseClickOutside(event) {
    if (!document.getElementById('mobileMenu').contains(event.target)
        && !document.getElementById('mobileHeader').contains(event.target)) {
        toggleMobileMenu();
    }
}